// src/hooks/useInViewport.js
import { useEffect, useRef, useState } from "react";

export function useInViewport(options = { rootMargin: "300px" }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof window.IntersectionObserver === "undefined") return;

    const io = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setInView(true);
          io.unobserve(entry.target); // one-shot mode
        }
      },
      options
    );

    io.observe(el);

    return () => {
      io.disconnect();
    };
  }, [options.rootMargin]); // options itself may be recreated each render

  return [ref, inView];
}
